<template>
<GlobalModal
    :modalInfo="{
        class: 'user-logs-modal'
    }"
    
    @onClose="$emit('close')"
>
    <template v-slot:customContent>
        <div class="header">
            <h3>{{ toLocal('users.user_logs') || 'Vartotojų įrašai' }}</h3>
        </div>
        
        <!-- <div class="filters">
            <div class="filter-row">
                <input 
                    v-model="filters.search_data" 
                    type="text" 
                    placeholder="Ieškoti..."
                    @input="debouncedSearch"
                    class="search-input"
                />
                <select v-model="filters.action" @change="resetAndFetchLogs" class="filter-select">
                    <option value="">Visi veiksmai</option>
                    <option value="login">Prisijungimas</option>
                    <option value="logout">Atsijungimas</option>
                    <option value="training">Mokymai</option>
                    <option value="appointment">Paskyrimas</option>
                </select>
            </div>
        </div> -->
        <div class="logs-container">
            <span 
                v-if="logs.length > 0 && !infiniteLoadingEnabled" 
                class="show-more-row" 
                @click="enableInfiniteLoading" 
                :class="{'active': infiniteLoadingEnabled}" 
            >
                <div class="icon">
                    <svg  width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.82993 4.36948L0.986006 7.84696C0.877687 7.94495 0.730775 8 0.577589 8C0.424403 8 0.277491 7.94495 0.169172 7.84696C0.0608528 7.74896 1.14133e-09 7.61606 0 7.47747C-1.14133e-09 7.33889 0.0608528 7.20599 0.169172 7.10799L3.60516 4.00043L0.170133 0.892008C0.116499 0.843487 0.0739538 0.785884 0.0449272 0.722488C0.0159007 0.659092 0.000960821 0.591145 0.00096082 0.522526C0.000960819 0.453907 0.0159007 0.38596 0.0449272 0.322564C0.0739538 0.259168 0.116499 0.201565 0.170133 0.153044C0.223767 0.104523 0.28744 0.0660344 0.357516 0.039775C0.427593 0.0135156 0.5027 -5.11252e-10 0.57855 0C0.6544 5.11252e-10 0.729507 0.0135156 0.799584 0.039775C0.86966 0.0660344 0.933333 0.104523 0.986967 0.153044L4.83089 3.63052C4.88458 3.67904 4.92716 3.73666 4.95618 3.8001C4.9852 3.86353 5.00009 3.93153 5 4.00018C4.99991 4.06883 4.98484 4.13679 4.95566 4.20017C4.92647 4.26354 4.88375 4.32108 4.82993 4.36948Z" fill="#7D7E81"/>
                    </svg>
                </div>
                <span>
                    {{toLocal('generic.show_more')}}
                </span>
            </span>
    
            <div class="logs-content" :class="{'scrollable': infiniteLoadingEnabled}" v-if="!loading">
                <div class="timeline">
                    <div 
                        class="log-group" 
                        v-for="(group, date) in groupedLogs" 
                        :key="date"
                    >
                        <div class="log-entry" 
                             v-for="log in group" 
                             :key="log.id"
                        >
                            <div class="log-main">
                                <span class="date">
                                    <div class="icon circle">
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="4" cy="4" r="3.5" fill="#6A6A6A"/>
                                        </svg>
                                    </div>
                                    {{getFormattedDate(log.created_at)}}
                                </span>
                                <div class="log-content">
                                    <!-- <div class="log-header">
                                        <span class="log-time">{{ formatDateTime(log.created_at) }}</span>
                                    </div> -->
                                    <div class="log-details">
                                        <div class="log-user">
                                            <span>
                                                {{ log.user_info ? log.user_info.full_name : '' }}
                                            </span>
                                            <div class="icon circle yellow" v-if="log.condition_training_info">
                                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="4" cy="4" r="3.5" fill="#6A6A6A"/>
                                                </svg>
                                            </div>
                                            <span v-if="log.condition_training_info">
                                                {{ log.condition_training_info.title }}
                                            </span>
                                        </div>
                                        <div class="log-action">
                                                <span>
                                                    {{ toLocal('user_logs.not_viewed_training_in_time') }}
                                                </span>
                                                <div class="icon circle red" v-if="log.parsed_data && log.parsed_data.date_term">
                                                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="4" cy="4" r="3.5" fill="#6A6A6A"/>
                                                    </svg>
                                                </div>
                                                <span class="term" v-if="log.parsed_data && log.parsed_data.date_term">
                                                    {{toLocal('generic.term')}}: 
                                                    <span class="date-smaller">
                                                        {{ log.parsed_data.date_term.split(' ')[0].split('T')[0] }}
                                                    </span>
                                                </span>

                                        </div>
                                        <div class="log-result">
                                            <span>
                                                {{log.parsed_data.status == 'error' ? toLocal('user_logs.did_not_assign_training') : toLocal('user_logs.assigned_training')}}
                                            </span>
                                             <div 
                                                class="icon circle" 
                                                :class="[log.parsed_data.status == 'error' ? 'red' : 'green']" 
                                                v-if="log.parsed_data.status"
                                             >
                                                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="4" cy="4" r="3.5" fill="#6A6A6A"/>
                                                    </svg>
                                            </div>
                                            <span class="training-title" :title="log.training_info ? log.training_info.title : ''">
                                                {{ log.training_info ? log.training_info.title : '-' }}
                                            </span>
                                             <div 
                                                class="icon circle" 
                                                :class="[log.parsed_data.status == 'error' ? 'red' : 'green']" 
                                                v-if="log.parsed_data.status"
                                             >
                                                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="4" cy="4" r="3.5" fill="#6A6A6A"/>
                                                    </svg>
                                            </div>
                                            <span class="term">
                                                {{toLocal('generic.date')}}:
                                                <span class="date-smaller">
                                                    {{ log.formatted_updated_at ? log.formatted_updated_at.split(' ')[0] : '-' }}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    
                        
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-records" v-if="Object.keys(groupedLogs) == 0">
                        {{ toLocal('generic.no_records') }}
                    </div>
                </div>
           
            <!-- Load More Indicator -->
            <div class="load-more" v-if="loadingMore">
                <div class="loading-spinner small"></div>
                <p>{{toLocal('user_logs.loading_more_records')}}...</p>
            </div>
            
            <!-- End of Data Indicator -->
            <div class="end-of-data" v-if="!hasMoreData && logs.length > 0 && infiniteLoadingEnabled">
                <p>{{toLocal('user_logs.all_records_loaded')}}</p>
            </div>
            
            
            </div>
             <span 
                v-if="logs.length > 0 && infiniteLoadingEnabled" 
                class="show-less-row" 
                @click="disableInfiniteLoading" 
            >
                <div class="icon">
                    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.36948 0.170068L7.84696 4.01399C7.94495 4.12231 8 4.26923 8 4.42241C8 4.5756 7.94495 4.72251 7.84696 4.83083C7.74896 4.93915 7.61606 5 7.47747 5C7.33889 5 7.20599 4.93915 7.10799 4.83083L4.00043 1.39484L0.892008 4.82987C0.843487 4.8835 0.785884 4.92605 0.722488 4.95507C0.659092 4.9841 0.591145 4.99904 0.522526 4.99904C0.453907 4.99904 0.38596 4.9841 0.322564 4.95507C0.259168 4.92605 0.201565 4.8835 0.153044 4.82987C0.104523 4.77623 0.0660344 4.71256 0.039775 4.64248C0.0135156 4.57241 -5.11252e-10 4.4973 0 4.42145C5.11252e-10 4.3456 0.0135156 4.27049 0.039775 4.20042C0.0660344 4.13034 0.104523 4.06667 0.153044 4.01303L3.63052 0.169108C3.67904 0.115417 3.73666 0.0728416 3.8001 0.0438223C3.86353 0.0148029 3.93153 -8.86917e-05 4.00018 4.76837e-07C4.06883 9.01222e-05 4.13679 0.0151587 4.20017 0.044343C4.26354 0.0735269 4.32108 0.116252 4.36948 0.170068Z" fill="#333333"/>
                    </svg>
                </div>
                <span>
                    {{toLocal('user_logs.show_less')}}
                </span>
            </span>
        </div>

    </template>
</GlobalModal>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import GlobalModal from './GlobalModal.vue';
export default {
    props: {
        userId: {
            type: [Number, String],
            default: null
        }
    },
    components: {
        GlobalModal
    },
    data() {
        return {
            logs: [],
            loading: false,
            loadingMore: false,
            hasMoreData: true,
            expandedLogs: [],
            infiniteLoadingEnabled: false,
            filters: {
                search_data: '',
                action: '',
                per_page: 5,
                page: 1
            },
            pagination: {
                current_page: 1,
                last_page: 1,
                total: 0
            },
            debouncedSearch: null,
        }
    },
    computed: {
        groupedLogs() {
            const grouped = {}
            let logs = this.logs;
            if(!this.infiniteLoadingEnabled){
                logs = logs.slice(0,this.filters.per_page)
            }
            logs.forEach(log => {
                const date = this.formatDate(log.created_at)
                if (!grouped[date]) {
                    grouped[date] = []
                }
                grouped[date].push(log)
            })
            return grouped
        }
    },
    mounted() {
        this.fetchLogs()
        this.debouncedSearch = _.debounce(this.resetAndFetchLogs, 500)
        // Don't setup scroll listener initially - only after "show more" is clicked
    },
    beforeDestroy() {
        this.removeScrollListener()
    },
    methods: {
        async fetchLogs(append = false) {
            if (append) {
                this.loadingMore = true
            } else {
                this.loading = true
            }
            
            try {
                const params = new URLSearchParams({
                    page: this.filters.page,
                    per_page: this.filters.per_page,
                    sort_by: 'created_at',
                    sort_order: 'desc'
                })
                
                if (this.userId) {
                    params.append('user_id', this.userId)
                }
                
                if (this.filters.search_data) {
                    params.append('search_data', this.filters.search_data)
                }
                
                if (this.filters.action) {
                    params.append('action', this.filters.action)
                }
                
                // Filter only physical_appointment_assign records
                params.append('log_key', 'physical_appointment_assign')
                
                axios.get(
                `${this.$store.state.api_link}/user/logs?${params}`,
                this.$store.getters.axiosConfig()
                )
                .then((response) => {
                    if (response.data.status === 'success') {
                        const newLogs = response.data.data
                        
                        if (append) {
                            // Filter out duplicates based on ID
                            const existingIds = new Set(this.logs.map(log => log.id))
                            const uniqueNewLogs = newLogs.filter(log => !existingIds.has(log.id))
                            this.logs = [...this.logs, ...uniqueNewLogs]
                        } else {
                            this.logs = newLogs
                        }
                        
                        this.pagination = response.data.pagination
                        this.hasMoreData = response.data.pagination.has_more_pages
                    }
                }).catch ((error) => {
                    console.error('Failed to fetch user logs:', error)
                })
            } catch (error) {
                console.error('Failed to fetch user logs:', error)
            } finally {
                this.loading = false
                this.loadingMore = false
            }
        },
        
        async loadMore() {
            if (this.loadingMore || !this.hasMoreData) return
            
            this.filters.page += 1
            await this.fetchLogs(true)
        },
        
        async resetAndFetchLogs() {
            this.filters.page = 1
            this.hasMoreData = true
            await this.fetchLogs(false)
        },
        
        setupScrollListener() {
            this.scrollContainer = document.querySelector('.logs-content')
            if (this.scrollContainer) {
                this.scrollContainer.addEventListener('scroll', this.handleScroll)
            }
        },
        
        removeScrollListener() {
            if (this.scrollContainer) {
                this.scrollContainer.removeEventListener('scroll', this.handleScroll)
            }
        },
        
        handleScroll: _.throttle(function() {
            if (!this.scrollContainer || !this.infiniteLoadingEnabled) return
            
            const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer
            const threshold = 100 // Load more when 100px from bottom
            
            if (scrollTop + clientHeight >= scrollHeight - threshold) {
                this.loadMore()
            }
        }, 200),
      
        getFormattedDate(date){
            if (!date) return '';
            
            // Parse the UTC date string
            let date_formatted = new Date(date);
            
            // Format in Europe/Vilnius timezone (UTC+2/+3)
            const formatter = new Intl.DateTimeFormat('sv-SE', {
                timeZone: 'Europe/Vilnius',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });
            
            const formatted = formatter.format(date_formatted);
            return formatted.replace(',', '');
        },
        enableInfiniteLoading() {
            this.infiniteLoadingEnabled = true
            // Change per_page to 20 for infinite loading
            this.filters.per_page = 5
            this.setupScrollListener()
            // Load more data immediately when enabling infinite loading
            this.loadMore()
        },
        disableInfiniteLoading() {
            this.infiniteLoadingEnabled = false
            // Change per_page to 20 for infinite loading
            this.filters.per_page = 5;
            this.removeScrollListener();
            // Load more data immediately when enabling infinite loading
        },
        toggleLogDetails(logId) {
            const index = this.expandedLogs.indexOf(logId)
            if (index > -1) {
                this.expandedLogs.splice(index, 1)
            } else {
                this.expandedLogs.push(logId)
            }
        },
        
        formatDateTime(dateString) {
            const date = new Date(dateString)
            return date.toLocaleString('lt-LT', {
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        
        formatDate(dateString) {
            const date = new Date(dateString)
            return date.toLocaleDateString('lt-LT')
        },
        
        hasTrainingInfo(log) {
            return log.parsed_data && (log.parsed_data.training_id || log.parsed_data.main_training_id)
        },
        
        getTrainingInfo(log) {
            if (log.parsed_data && log.parsed_data.main_training_id) {
                return `Mokymas #${log.parsed_data.main_training_id}`
            }
            return ''
        },
        
        formatKey(key) {
            return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
        },
        
        formatValue(value) {
            if (typeof value === 'object') {
                return JSON.stringify(value, null, 2)
            }
            return value
        }
    }
}
</script>

<style scoped lang="scss">
.user-logs-modal {
    width: 100vw;
    height: 100vh;
    font-size: 14px;
    .modal-box{
        max-width: 650px;
        width: 100%;
    }
}
.training-title{
    max-width: 190px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.show-more-row{
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-weight: 600;
    cursor: pointer;
   
    svg{
        width: 6px;
        height: 10px;
        transition: transform 0.3s;
    }
    &.active{
        svg{
            transform: rotate(90deg);
        }
    }
}

.show-less-row{
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-weight: 600;
    cursor: pointer;
    .icon{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    svg{
        width: 10px;
        height: 6px;
        transition: transform 0.3s;
    }
}
.date-smaller{
    font-weight: 600;
    color: #333333;
}
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}
.logs-container{
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    padding: 1rem 2rem;
    width: 100%;
}
.term{
    display: flex;
    gap: 4px;
    align-items: center;

}
.header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #374151;
}
.log-result{
    display: flex;
    align-items: center;
    gap: 4px;
}
.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #6b7280;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
}

.close-btn:hover {
    background-color: #f3f4f6;
    color: #374151;
}

.filters {
    padding: 16px 20px;
    border-bottom: 1px solid #e5e7eb;
    background: #f9fafb;
    width: 100%;
}

.filter-row {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
}

.search-input, .filter-select {
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 14px;
}

.search-input {
    flex: 1;
}

.filter-select {
    min-width: 150px;
}

.show-more {
    margin-top: 8px;
    color: #6b7280;
    font-size: 12px;
    cursor: pointer;
}

.logs-content {
    padding: 0;
    min-width: 100%;
    overflow-y: hidden;
    &.scrollable{
    overflow-y: auto;

    }
}

.timeline {
    position: relative;
}

.log-group {
    width: fit-content;
    min-width: 80%;
    margin-bottom: 12px;
}

.log-entry {
    user-select: text;
    cursor: text;
    color: #4D4D4D;
    transition: background-color 0.2s;
    &:last-child{
        .log-main{
            border-bottom: none;
        }
    }
}
.icon{
    width: 18px;
}

.log-main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 0px 16px 0;
    gap: 4px;
    border-bottom: 1px solid #f3f4f6;
}

.log-bullet {
    flex-shrink: 0;
    margin-right: 12px;
    margin-top: 4px;
}

.bullet-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #6b7280;
}

.bullet-dot.success { background-color: #10b981; }
.bullet-dot.warning { background-color: #f59e0b; }
.bullet-dot.info { background-color: #3b82f6; }
.bullet-dot.primary { background-color: #8b5cf6; }
.circle{
    &.yellow{
        svg{
            circle{
                fill: #F1E783;
            }
        }
    }
    &.red{
        svg{
            circle{
                fill: #F56363;
            }
        }
    }
    &.green{
        svg{
            circle{
                fill: #6ACD77;
            }
        }
    }
}
.log-content {
    display: flex;
  flex-direction: column;
  align-items: flex-start;
    flex: 1;
}

.log-header {
    margin-bottom: 4px;
}

.log-time {
    font-size: 14px;
    color: #374151;
    font-weight: 500;
}

.log-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: flex-start;
    font-weight: medium;
    padding-left: 26px;
}
.date{
    display: flex;
    align-items: center;
    gap: 8px;
    
    font-weight: 700;
}
.log-user {

    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
}

.log-action {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
}
.circle{
    width: 18px;
}

.log-action.success { color: #10b981; }
.log-action.warning { color: #f59e0b; }
.log-action.info { color: #3b82f6; }
.log-action.primary { color: #8b5cf6; }

.log-description, .log-training {
    font-size: 13px;
    color: #6b7280;
}

.log-expanded {
    margin-top: 12px;
    padding: 12px;
    background-color: #f9fafb;
    border-radius: 6px;
    border-left: 3px solid #e5e7eb;
}

.data-item {
    margin-bottom: 4px;
    font-size: 13px;
}

.meta-info {
    margin-top: 8px;
    color: #9ca3af;
    font-size: 11px;
}

.load-more {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: #6b7280;
}

.load-more .loading-spinner.small {
    width: 20px;
    height: 20px;
    border-width: 2px;
    margin-bottom: 8px;
}

.end-of-data {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    color: #9ca3af;
    font-size: 14px;
    border-top: 1px solid #f3f4f6;
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #6b7280;
}

</style>
<style lang="scss">

.user-logs-modal {
    width: 100vw;
    height: 100vh;

    .modal-box{
        max-width: 650px;
        min-height: 70vh;
        width: 100%;
        height: 680px;
        min-height: 70vh;
        max-height: 95vh;
        justify-content: flex-start;
        align-items: flex-start;
    }
    @media (max-width: 768px), (max-width: 1000px) and (max-height: 512px){
        .modal-box{
            max-width: 100%;
            min-height: 100%;
            width: 100%;
            height: 100%;
            max-height: 100vh;
            border-radius: 0;
        }
    }
}
</style>